module.exports = __webpack_public_path__ + "book_open_3.d669c6114745915179b3afee27197357.svg";